<template>
  <AllegroJsonForm
    title="Edytuj nadawcę Allegro"
    crumbLabel="Edycja nadawcy"
    :settingsCrumb="true"
    submitAction="updateAllegroSender"
    submitGetter="getAllegroSenderUpdateData"
    loadAction="getAllegroSender"
    loadGetter="getAllegroSenderData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSenderPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSenderUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSenderPermissionsConst.update,
      fields: [
        { key: "company_name", label: "Nazwa firmy", required: true },
        { key: "name", label: "Imię i Nazwisko", required: true },
        { key: "street", label: "Ulica", required: true },
        { key: "zip_code", label: "Kod pocztowy", required: true },
        { key: "city", label: "Miejscowość", required: true },
        { key: "country_code", label: "Kod kraju", required: true },
        { key: "email", label: "E-mail", type: "email", required: true },
        { key: "phone", label: "Nr telefonu", required: true },
      ],
    };
  },
};
</script>
